import { Table } from "antd";
import React, { useEffect, useState } from "react";
import PositionFuture from "../PositionFuture";
import TradeHistoryFuture from "../TradeHistoryFutures";
import BalanceFundFuture from "../BalanceFundFuture";
import axios from "axios";

const FutureTrade = (props) => {
  const [activeKey, setActiveKey] = useState("1");

  const { type, apiKey, apiSecret, selectedapi } = props;
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);

  // State to hold selected API's Exchange and Exchange_Type
  const [exchangeInfo, setExchangeInfo] = useState();

  const renderContent = () => {
    switch (activeKey) {
      case "1":
        return <PositionFuture data={{
          selectedapi: selectedapi,
          apiKey: apiKey,
          apiSecret: apiSecret,
          type: type,
          selectedOptionData: exchangeInfo,
        }} />;
     
      case "2":
        return <TradeHistoryFuture data={{
          selectedapi: selectedapi,
          apiKey: apiKey,
          apiSecret: apiSecret,
          type: type,
          selectedOptionData: exchangeInfo,
        }} />;
        // case "3":
        //   return <BalanceFundFuture data={{
        //     selectedapi: selectedapi,
        //     apiKey: apiKey,
        //     apiSecret: apiSecret,
        //     type: type,
        //     selectedOptionData: exchangeInfo,
        //   }} />;
      default:
        return null;
    }
  };

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  const items = [
    {
      key: "1",
      label: <div className='px-4 md:px-10  text-xs md:text-sm'>Positions</div>,
    },
    {
      key: "2",
      label: <div className='px-4 md:px-10  text-xs md:text-sm'>Order History</div>,
    },
    // {
    //   key: "3",
    //   label: <div className='px-4 md:px-10  text-xs md:text-sm'>Order History</div>,
    // },
  ];



  const checkSpotBalance = () => {
    setLoading(true);
    const token = localStorage.getItem("jwt");
  
  
    const secondApiData = {
      request_type: "private",
      method: "GET",
      key: apiKey,
      secret: apiSecret,
      endpoint: "/fapi/v2/account",
    };
  
    axios({
      method: "POST", 
      headers: { "Content-Type": "application/json" },
      url: process.env.REACT_APP_API_ALLCOINSF + "/make_request",
      data: secondApiData,
    })
      .then((secondRes) => {
        setLoading(false);
        setApiData(secondRes.data.Success); 
      })
      .catch((err) => {
        setLoading(false);
        console.error("Error from second API:", err);
      });
  };
  

  useEffect(() => {
    if (selectedapi) {
      checkSpotBalance();
    }
  }, [selectedapi]);




  return (
    <>
      <div className=" text-black ">
        {/* Balance Section */}
        <div className="flex justify-between gap-4">
          {/* Margin Balance */}
          <div className=" p-4 rounded-lg">
            <h2 className="text-sm font-semibold border-b border-gray-600 pb-2">
              Margin Balance
            </h2>
            <p className="text-xs font-bold mt-2">
              {apiData.totalMarginBalance} <span className="text-sm">USDT</span>
            </p>
            {/* <p className="text-xs text-gray-400 mt-1">≈ $2,071.22</p> */}
          </div>

          {/* Wallet Balance */}
          <div className=" p-4 rounded-lg">
            <h2 className="text-sm font-semibold border-b border-gray-600 pb-2">
              Wallet Balance (USDT)
            </h2>
            <p className="text-xs font-bold mt-2">
            {apiData.totalWalletBalance} <span className="text-sm">USDT</span>
            </p>
            {/* <p className="text-xs text-gray-400 mt-1">≈ $2,158.58</p> */}
          </div>

          {/* Total Balance and Maintenance Margin */}


          <div className=" p-4">
            <h2 className="text-sm font-semibold border-b border-gray-600 pb-2">
              Total Available Balance (USDT)
            </h2>
            <p className="text-xs font-bold mt-1">
            {apiData.totalMarginBalance} <span className="text-sm">USDT</span>
            </p>
            {/* <p className="text-xs text-gray-400 mt-1">≈ $2,060.31</p> */}
          </div>
          <div className="p-4">
            <h2 className="text-sm font-semibold border-b border-gray-600 pb-2">
              Total Maintenance Margin (USDT)
            </h2>
            <p className="text-xs font-bold mt-1">
            {apiData.totalMaintMargin} <span className="text-sm">USDT</span>
            </p>
            {/* <p className="text-xs text-gray-400 mt-1">≈ $5.25</p> */}
          </div>

          <div className=" p-4">
            <h2 className="text-sm font-semibold border-b border-gray-600 pb-2">
            Total Initial Margin (USDT)
            </h2>
            <p className="text-xs font-bold mt-1">
            {apiData.totalInitialMargin} <span className="text-sm">USDT</span>
            </p>
            {/* <p className="text-xs text-gray-400 mt-1">≈ $2,071.01</p> */}
          </div>


        


        </div>

        {/* // table section of Spot Trade  */}

        <div className="text-black">
          <div className="tab-headers flex space-x-4 border-b">
            {items.map((item) => (
              <div
                key={item.key}
                className={`tab-header cursor-pointer p-2 ${activeKey === item.key
                    ? "border-b-2 border-black font-semibold"
                    : ""
                  }`}
                onClick={() => handleTabChange(item.key)}
              >
                {item.label}
              </div>
            ))}
          </div>

          <div className="tab-content mt-4">{renderContent()}</div>
        </div>
      </div>
    </>
  );
};

export default FutureTrade;
